module.exports = __webpack_public_path__ + "InterstateWGL-Light.b6e61aeb11e63d8ab506.woff";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/InterstateWGL-Light.woff
// module id = ../../../../../src/assets/layout/fonts/InterstateWGL-Light.woff
// module chunks = styles